// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext, useEffect, useState} from 'react';
import styles from './form.module.less';
import cn from 'classnames';
import {t_states} from './types';
import Chevron_left from '../../img/icons/24/chevron_left.svg';
import {login_process, up} from './utils';
import {perr} from 'hola_pub_util';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import etask from 'zetask';
import {Input} from '../../../../hola/pub/lib/input';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../lib/button';
import {Checkbox} from '../../lib/checkbox';

interface i_two_step_props {
    go_to: (type:t_states, direction?: number)=>void;
    get_enc_url: ()=>string;
    email: string;
    no_banner?: boolean;
    Banner?: JSX.Element;
    support_email?: string;
}

export const State_two_step = (props: i_two_step_props)=>{
    const {theme} = useContext(Settings_context);
    const [loading, set_loading] = useState(false);
    const [token, set_token] = useState('');
    const [error, set_error] = useState('');
    const [save, set_save] = useState(true);
    const send_email = ()=>{
        return fetch(up+'/auth/two_step/send_email',
            {method: 'POST', no_throw: true});
    };
    useEffect(()=>{
        perr({id: 'www_two_step_verif_view', info: {email: props.email}});
        send_email();
    }, []);
    const verify_token = ()=>etask(function*(){
        if (!token)
            return void set_error('bad token');
        set_loading(true);
        let res = yield fetch(up+'/auth/two_step/verify_token', {
            method: 'POST',
            body: JSON.stringify({token, save}),
            contentType: 'application/json',
            no_throw: true,
        });
        set_loading(false);
        if (res && res.error)
        {
            if (res.data=='token expired')
                yield send_email();
            perr({id: 'www_two_step_verif_error', info:
                {email: props.email, error: res.data}});
            set_error(res.data || 'error');
        }
        else
        {
            perr({id: 'www_two_step_verif_done',
                info: {email: props.email}});
            login_process.login_done(props.email, props.get_enc_url);
        }
    });
    const get_error = ()=>{
        if (!error)
            return '';
        if (error=='bad token')
            return 'Invalid token';
        else if (error=='token expired')
            return 'Expired token. A new token has been sent';
        return 'We\'ve encountered an error. Please try again later.';
    };
    const h_email = props.support_email || 'help@hola.org';
    return <div className={cn(styles.form_content, styles.two_step)}>
        <div className={styles.head}>
          <button className={styles.back_btn} onClick={()=>{
            props.go_to('login_with_email', -1);
          }}><Chevron_left/></button>
          <p className={cn(theme.p20, theme.bold, theme.color_n700)}>
            <b>2-step Verification</b></p>
        </div>
        <div className={styles.two_step_text}>
          <p className={theme.p4}>We've noticed you're logging in from a new
            location and require
            an extra step to complete your login.<br/><br/>
            A 2-Step Verification email from Oculus has been sent
            to <u>{props.email}</u> - the 6-digit code will be valid for
            15min.</p>
        </div>
        <form className={styles.two_step_field}>
          <p className={cn(theme.p12, theme.med)}>Your PIN</p>
          <div className={styles.code_preview_wrapper}>
            <Input value={token}
              on_change={v=>{
                const no_space = (v || '').replace(/ /g, '');
                if (no_space.length <= 6)
                  set_token(no_space);
              }} cl={styles.code_input} error={get_error()}/>
          </div>
          <Button caption={'Verify'}
            cls={styles.verify_button}
            on_click={()=>{ verify_token(); }}
            disabled={loading}/>
          <div className={styles.message_checkbox}>
            <Checkbox caption={''} checked={save} on_change={set_save} size="s"
              cls={styles.checkbox}/>
            <p className={cn(theme.p12)}>Don't ask for codes again on this
              device</p>
          </div>
          <p className={cn(theme.p12, styles.two_step_bottom)}>
            You may need to check your spam folder.<br/>
            Problems? Contact us at <a href={`mailto:${h_email}`}
              className={styles.underline}>{h_email}</a>
          </p>
        </form>
      </div>;
};
